export default __webpack_public_path__ + "static/media/guide_to_diligence.0b1dcce9.png";